import {
    Component,
    EventEmitter,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Router } from '@angular/router';
import {
    AuthenticationService,
    EspaceClientService,
} from '@kv-common-components/kx-services';
import { PersonneHelperService } from '@shared/services/personne-helper.service';
import { UserIdleService } from 'angular-user-idle';
import { environment } from '@env/environment';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';

@Component({
    /* eslint-disable-next-line @angular-eslint/component-selector */
    selector: '[appHeaderProfile]',
    templateUrl: './header-profile.component.html',
    styleUrls: ['header-profile.component.scss'],
})
export class HeaderProfileComponent implements OnInit, OnDestroy {
    @Output() toggleLeftMenuMobile = new EventEmitter<boolean>();
    @Output() toggleNoscroll = new EventEmitter<boolean>();
    @Output() logoutRequested = new EventEmitter<boolean>();

    displayHeaderMenu = false;
    changePasswordVisibility = false;
    confirmDeconnexion = false;
    isLoggedIn = false;
    sessionExpired = false;
    currentEspaceClient: any;
    failedCheckCounter = 0;
    nom: string;
    prenom: string;
    civilite: string;

    pingSubscription: Subscription;
    espaceClientSubscription: Subscription;
    userSubscription: Subscription;

    constructor(
        private personneHelperService: PersonneHelperService,
        public router: Router,
        private espaceClientService: EspaceClientService,
        private authenticationService: AuthenticationService,
        private userIdle: UserIdleService,
        private logger: NGXLogger
    ) {}

    ngOnInit(): void {
        this.espaceClientSubscription =
            this.espaceClientService.currentEspaceClient.subscribe((data) => {
                this.nom = data.personne.nom.toUpperCase();
                this.prenom = data.personne.prenom;
                this.civilite = this.personneHelperService.getCivilite(
                    data.personne.codeCivilite
                );
                this.currentEspaceClient = data;
                this.initUserIdleForLogout();
            });

        this.userSubscription =
            this.authenticationService.currentUser.subscribe((data) => {
                if (data) {
                    this.isLoggedIn = true;
                } else {
                    this.isLoggedIn = false;
                }
            });
    }

    ngOnDestroy() {
        if (this.pingSubscription) {
            this.pingSubscription.unsubscribe();
        }
        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }

    getCivilite(codeCivilite: string) {
        return this.personneHelperService.getCivilite(codeCivilite);
    }

    toggleLogout() {
        this.confirmDeconnexion = true;
    }
    logout() {
        this.confirmDeconnexion = false;
        this.pingSubscription.unsubscribe();
        this.userIdle.stopWatching();
        this.authenticationService.logout();
        this.logoutRequested.emit();
        this.router.navigateByUrl('/connexion');
    }

    initUserIdleForLogout() {
        const maxRepeat = Number(environment.refreshToken.maxRepeat);
        const timeRepeat = Number(environment.refreshToken.timeRepeat) * 60;
        const sessionTimeout = maxRepeat * timeRepeat;

        this.userIdle.setConfigValues({
            idle: sessionTimeout,
            timeout: 10,
            ping: timeRepeat,
        });
        this.userIdle.startWatching();
        this.userIdle.onTimerStart().subscribe(() => {
            this.logger.info('La session va expirer !');
            this.pingSubscription.unsubscribe();
        });
        this.userIdle.onTimeout().subscribe(() => {
            this.logger.info('Session fermee !');
            this.sessionExpired = true;
            this.logout();
        });
        this.pingSubscription = this.userIdle.ping$.subscribe(() =>
            this.controlAndRefreshToken(maxRepeat)
        );
    }

    controlAndRefreshToken(maxRepeat: number) {
        const user = this.authenticationService.currentUserValue;
        if (user && user.accessToken) {
            if (this.failedCheckCounter >= maxRepeat) {
                this.logout();
                return;
            }

            try {
                this.authenticationService
                    .postRefresh()
                    .toPromise()
                    .then(() => {
                        this.checkAccessToken();
                    });
            } catch (error) {
                this.countTokenReFreshFailed(error);
            }
        } else {
            this.logger.info('Utilisateur deconnecte.');
        }
    }

    checkAccessToken() {
        try {
            const idPersonne =
                this.authenticationService.currentUserValue.idPersonne;
            const newAccessToken =
                this.authenticationService.currentUserValue.accessToken;

            if (newAccessToken) {
                this.failedCheckCounter = 0;
                this.logger.info(
                    'Refresh Token success for Personne with id : ',
                    idPersonne
                );
            } else {
                this.countTokenReFreshFailed(new Error('No token find !'));
            }
        } catch (error) {
            this.countTokenReFreshFailed(error);
        }
    }

    countTokenReFreshFailed(error) {
        this.failedCheckCounter += 1;
        this.logger.error('Refresh Token failed : ', error.message);
    }

    toggleMobileLeftMenu() {
        this.displayHeaderMenu = !this.displayHeaderMenu;
        this.toggleLeftMenuMobile.emit();
    }
    togglePasswordChange() {
        this.changePasswordVisibility = !this.changePasswordVisibility;
        this.toggleMobileLeftMenu();
        this.toggleNoscroll.emit();
    }
}
